import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { ApiService } from 'src/app/_services/api.service';

import { FileMimeType} from './mimetypes';

@Component({
  selector: 'app-widget-documenti',
  templateUrl: './widget-documenti.component.html',
  styleUrls: ['./widget-documenti.component.css'],
  encapsulation: ViewEncapsulation.None

})
export class WidgetDocumentiComponent implements OnInit {
  @Output() messageEvent = new EventEmitter<number>();
  @Input() tipo: string;
  documentPdf:string='';
  showPdf:boolean=false;
  alberodocumenti: TreeNode[];
  cols=[{ field: 'name', header: '' },{ field: 'user', header: '' }];
  constructor( private apiService: ApiService) { }

  ngOnInit(): void {
    this.buildAlberoDocumenti();
  }
  
  private buildAlberoDocumenti(){
    let params={};
    if(this.tipo){
      let loggedUser=JSON.parse(localStorage.getItem('loggedUser'));
      params['tipo']=this.tipo;
      params['id_user']=loggedUser.id;
    }
    this.apiService.get('home/alberodocumenti',params).subscribe(data => {
      this.alberodocumenti =data.Result;
      this.messageEvent.emit(this.alberodocumenti.length);
    });
  }

  apridoc(doc){
    if(!doc.node.data.type) {
      return;
    }

    let mediaType='';
    Object.entries(FileMimeType).forEach(([key, value]) => {
      if(value.toUpperCase()==doc.node.data.type.toUpperCase()){
        mediaType=key;
      }
    });
 
    let loggedUser=JSON.parse(localStorage.getItem('loggedUser'));
    let params={
      id_doc:doc.node.data.id_doc,
      id_user:loggedUser.id
    };
    if(doc.node.data.type && doc.node.data.type.toUpperCase()=='PDF'){
  
      this.apiService.downloadPDF(params).subscribe(response => {
           mediaType = 'application/pdf';
          var blob = new Blob([response], { type: mediaType });
          const pdfUrl = URL.createObjectURL(blob);
          this.documentPdf=pdfUrl;
          this.showPdf=true;
  
      });
    } else {
      this.apiService.downloadPDF(params).subscribe(response => {
        const blob = new Blob([response],{ type: mediaType });
        const url= window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        let filename=doc.node.data.name.trimEnd()+'.'+doc.node.data.type;
      
        a.download = filename;
        a.click();
  
        window.URL.revokeObjectURL(url);
        a.remove();
      });
    }
  
   
  }

  scaricaPDF(){
    window.open(this.documentPdf, '_blank');
  }
 

}
